<template>
  <div class="flex flex-col">
    <OButton
      class="block focus:outline-none"
      :variant="variant"
      :class="{
        'added': added,
        'disabled': isDisabled
      }"
      :disabled="isDisabled"
      @click="onClick"
    >
      {{ text }}
    </OButton>
  </div>
</template>

<script>
import OButton from '@/components/OButton'

export default {
  name: 'ProductCTA',
  components: {
    OButton
  },
  props: {
    isSoldOut: {
      type: Boolean,
      default: false
    },
    isWalletFrozen: {
      type: Boolean,
      default: false
    },
    isAuthenticated: {
      type: Boolean,
      default: false
    },
    isProductVisible: {
      type: Boolean,
      default: false
    },
    hasEnoughCredits: {
      type: Boolean,
      default: false
    },
    shouldRemoveCartItems: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      added: false
    }
  },
  computed: {
    variant () {
      return 'secondary'
    },
    isDisabled () {
      if (this.isSoldOut || !this.isProductVisible) {
        return true
      }

      return false
    },
    text () {
      if (this.isWalletFrozen) {
        return this.$t('Loyalty.Webshop.ProductDetail.FirstActivateMembership')
      }

      if (!this.isAuthenticated) {
        return this.$t('Loyalty.Webshop.CTA.ATC')
      }

      if (this.isSoldOut || !this.isProductVisible) {
        return this.$t('Loyalty.Webshop.CTA.ATC')
        // return this.$t('Loyalty.Webshop.ProductDetail.NotifyMe')
      }

      return this.$t('Loyalty.Webshop.CTA.ATC')
    }
  },
  watch: {
    added: {
      handler (newAdded) {
        if (newAdded) {
          setTimeout(() => {
            this.added = false
          }, 3000)
        }
      }
    }
  },
  methods: {
    onClick () {
      const { isProductVisible, hasEnoughCredits, isWalletFrozen, isAuthenticated, isSoldOut } = this

      if (isProductVisible && hasEnoughCredits && !isWalletFrozen && isAuthenticated && !isSoldOut) {
        this.added = true
      }

      this.$emit('click')
    }
  }
}
</script>

<style lang="postcss" scoped>
.obutton {
  &.added {
    @apply bg-green-300 !important;
  }

  &.disabled {
    @apply bg-gray-200 text-gray-400 !important;
  }
}
</style>
